export const sortListObj = (list: any[], sortField: string, sortDirection: string = "asc") => {
    const l = list.sort((a, b) => {
        if (sortDirection === "asc") {
            return a[sortField] > b[sortField] ? 1 : -1;
        } else {
            return a[sortField] < b[sortField] ? 1 : -1;
        }
    });
    return l;
}

export const sortListString = (list: string[], sortDirection: string = "asc") => {
    return list.sort((a, b) => {
        if (sortDirection === "asc") {
            return a > b ? 1 : -1;
        } else {
            return a < b ? 1 : -1;
        }
    });
}
